import { useState } from "react";
import { ChatIcon } from "@shopify/polaris-icons";
import { Button, Card, FormLayout, Icon, TextField } from "@shopify/polaris";

const SupportChat = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    subject: "",
    message: "",
  });

  const toggleChat = () => {
    setIsOpen(!isOpen);
  };

  const handleChange = (value, id) => {
    console.log("E: ", id, value);
    setFormData({ ...formData, [id]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("formData: ", formData);

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/support-email/send-email`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      }
    );

    console.log("response: ", response);

    if (response.ok) {
      alert("Email sent successfully!");
      setFormData({ email: "", subject: "", message: "" });
      setIsOpen(false);
    } else {
      alert("Failed to send email");
    }
  };

  return (
    <div>
      {/* Floating Button */}
      <div
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          width: "40px",
          height: "40px",
          borderRadius: "50%",
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
          background: "#7ac1ff",
          cursor: "pointer",
          zIndex: 100000,
        }}
      >
        <Button variant="tertiary" onClick={toggleChat}>
          <Icon source={ChatIcon} tone="primary" />
        </Button>
      </div>

      {/* Support Form */}
      {isOpen && (
        <div
          style={{
            background: "red",
            position: "fixed",
            bottom: "80px",
            right: "20px",
            borderRadius: "12px",
            boxShadow: "0 0 10px rgba(0,0,0,0.2)",
            width: "300px",
            zIndex: 100000,
          }}
        >
          <Card background="bg-surface-secondary">
            <form onSubmit={handleSubmit}>
              <FormLayout>
                <TextField
                  label="Email"
                  type="email"
                  name="email"
                  id="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                <TextField
                  label="Subject"
                  type="text"
                  name="subject"
                  id="subject"
                  placeholder="Subject"
                  value={formData.subject}
                  onChange={handleChange}
                />
                <TextField
                  label="Message"
                  name="message"
                  id="message"
                  multiline={4}
                  placeholder="Your message"
                  value={formData.message}
                  onChange={handleChange}
                />
                <Button variant="primary" fullWidth submit>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      columnGap: "5px",
                    }}
                  >
                    <Icon source={ChatIcon} tone="base" /> Submit
                  </div>
                </Button>
              </FormLayout>
            </form>
          </Card>
        </div>
      )}
    </div>
  );
};

export default SupportChat;
